export default {
  text: {
    en: 'On sale at:',
  },
}
